import { IItemParams } from './itemParams';

export interface IItemSection {
    text: string;
    params: IItemParams[];
}

export class ItemSection implements IItemSection {
    constructor(
        public text: string,
        public params: IItemParams[],
    ) { }
}